@if (message()) {
  <div class="d-flex flex-column gap-2">
    <lib-reasoning-step
      [stepInfo]="{ stepLabel: 'Deep analysis', description: narrativeText() }"
      [isStreaming]="isStreaming()" />
    @if (analysisData().length > 0) {
      <div class="d-flex flex-column gap-2 ms-4">
        @for (item of analysisData(); track item.key) {
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center gap-2">
              <span class="mat-font-label-sm fw-semibold mat-text-on-surface-variant">{{ item.label }}</span>
              <span class="mat-font-label-sm mat-text-primary">{{ item.value }}</span>
            </div>
            @if (item.description) {
              <span class="mat-font-label-sm mat-text-on-surface-variant fst-italic">{{ item.description }}</span>
            }
          </div>
        }
      </div>
    }
  </div>
}
